import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { fetchJson } from '../../api';

/**
 * Sidebar listing all active services from the DB.
 * Shows a contact link only if the API fails or returns nothing.
 */
const ServiceSidebar = () => {
  const location = useLocation();
  const [services, setServices] = useState([]);

  useEffect(() => {
    let mounted = true;
    fetchJson('services').then((data) => {
      if (!mounted) return;
      setServices((data && data.services) || []);
    });
    return () => {
      mounted = false;
    };
  }, []);

  // Match by slug suffix so both /services/ivf and /services/s/ivf highlight.
  const activeSlug = (location.pathname.match(/services\/([a-z0-9-]+)/i) || [])[1] || '';

  return (
    <div className="services-sidebar">
      <h3>IVF &amp; Fertility Services in Ambala</h3>

      <ul>
        {services.map((s) => {
          const path = s.route_path || `/services/${s.slug}`;
          const isActive =
            (s.slug && activeSlug === s.slug) ||
            location.pathname === path ||
            (s.route_path && location.pathname.startsWith(s.route_path));
          return (
            <li className={isActive ? 'active' : ''} key={s.id || s.slug}>
              <Link to={path} title={s.name}>
                {s.name}
              </Link>
            </li>
          );
        })}
        {services.length === 0 && (
          <li>
            <Link to="/contact">Contact us for available treatments</Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default ServiceSidebar;
